export const fr = {
  // Global
  lang_name: 'Fran\u00e7ais',
  lang_code: 'fr',
  platform_name: 'Sovereign IQ',
  platform_subtitle: 'Plateforme de Renseignement',
  confidential: 'Confidentiel',
  loading: 'Chargement...',
  save: 'Enregistrer',
  cancel: 'Annuler',
  delete: 'Supprimer',
  search: 'Rechercher',
  submit: 'Soumettre',
  back: 'Retour',
  next: 'Suivant',
  close: 'Fermer',
  download: 'T\u00e9l\u00e9charger',
  export_csv: 'Exporter CSV',
  generating: 'G\u00e9n\u00e9ration en cours...',
  generated: 'G\u00e9n\u00e9r\u00e9',
  not_generated: 'Pas encore g\u00e9n\u00e9r\u00e9',
  success: 'Succ\u00e8s',
  error: 'Erreur',

  // Navigation
  nav_home: 'Site Principal',
  nav_dashboard: 'Tableau de Bord',
  nav_countries: 'Pays',
  nav_configuration: 'Configuration',
  nav_generator: 'G\u00e9n\u00e9rateur',
  nav_compare: 'Comparer',
  nav_documents: 'Documents',
  nav_use_cases: "Cas d'Usage",
  nav_user_management: 'Gestion des Utilisateurs',
  nav_pricing_model: 'Mod\u00e8le de Tarification',
  nav_ai_budget: 'Budget IA',
  nav_collapse: 'R\u00e9duire',
  nav_logout: 'D\u00e9connexion',

  // Landing Page
  landing_hero_title: 'Intelligence Souveraine',
  landing_hero_subtitle: "Analyse des risques pays et plans d'expansion globale de qualit\u00e9 investissement, pilot\u00e9s par l'IA",
  landing_cta: 'Commencer',
  landing_login: 'Connexion',
  landing_features_title: 'Capacit\u00e9s de la Plateforme',
  landing_doc: 'Documentation',
  landing_use_cases: "Cas d'Usage",
  landing_sources: 'Sources',
  landing_pricing: 'Tarification',

  // Login/Register
  login_title: 'Connexion',
  login_subtitle: 'Acc\u00e9dez \u00e0 votre tableau de bord',
  login_email: 'Adresse Email',
  login_password: 'Mot de Passe',
  login_btn: 'Se Connecter',
  login_register_link: 'Cr\u00e9er un compte',
  register_title: 'Inscription',
  register_subtitle: 'Rejoignez la plateforme Sovereign IQ',
  register_full_name: 'Nom Complet',
  register_company: 'Entreprise',
  register_location: 'Localisation (Ville, Pays)',
  register_areas: "Domaines d'Int\u00e9r\u00eat",
  register_btn: "S'inscrire",
  register_pending: "Votre inscription est en attente d'approbation.",
  register_login_link: 'D\u00e9j\u00e0 un compte ? Connectez-vous',

  // Dashboard
  dash_title: 'Tableau de Bord Intelligence Pays',
  dash_subtitle: 'Surveillance en temps r\u00e9el des risques souverains et intelligence \u00e9conomique',
  dash_intelligence_feed: 'Flux de Renseignement',
  dash_key_targets: 'Cibles Cl\u00e9s',
  dash_system_status: '\u00c9tat du Syst\u00e8me',
  dash_economic_forecasts: 'Pr\u00e9visions \u00c9conomiques FMI',
  dash_data_sources: 'Moniteur de Sources',
  dash_trend_chart: 'Tendance Historique',
  dash_world_map: 'Carte des Risques Mondiaux',

  // Countries
  countries_title: 'Cibles de Renseignement',
  countries_subtitle: 'Votre portefeuille de renseignement pays',
  countries_add: 'Ajouter un Territoire',
  countries_search: 'Rechercher des pays...',
  countries_no_results: 'Aucun pays trouv\u00e9',
  countries_sections: 'sections',
  countries_remaining: 'Rapports Restants',
  countries_pdf: 'Rapport PDF',
  countries_view: 'Voir le Plan',
  countries_delete_confirm: 'Supprimer ce pays et toutes ses donn\u00e9es ?',

  // Blueprint Config
  config_title: 'Configuration du Plan',
  config_subtitle: 'Configurez les param\u00e8tres de votre plan de renseignement pays',
  config_country: 'S\u00e9lectionner le Pays',
  config_sector: 'S\u00e9lectionner le Secteur',
  config_focus: 'Domaines de Focus',
  config_generate: 'G\u00e9n\u00e9rer le Plan',

  // Generator
  gen_title: 'G\u00e9n\u00e9rateur de Sections',
  gen_subtitle: "Synth\u00e8se de flux de donn\u00e9es multi-modaux pour une \u00e9valuation r\u00e9gionale haute fid\u00e9lit\u00e9.",
  gen_select_country: 'S\u00e9lectionner le pays',
  gen_generate_all: 'G\u00e9n\u00e9rer Tout (Texte + Illustrations)',
  gen_generate: 'G\u00e9n\u00e9rer',
  gen_regenerate: 'Reg\u00e9n\u00e9rer',
  gen_generate_illustration: "G\u00e9n\u00e9rer l'Illustration",
  gen_regenerate_illustration: "Reg\u00e9n\u00e9rer l'Illustration",
  gen_preview: 'Aper\u00e7u',
  gen_complete: 'Termin\u00e9',
  gen_draft: 'Brouillon',
  gen_illustrated: 'Illustr\u00e9',
  gen_creating_illustration: "Cr\u00e9ation de l'illustration...",
  gen_generating_synthesis: 'G\u00e9n\u00e9ration de la synth\u00e8se...',
  gen_regenerations_used: 'reg\u00e9n\u00e9rations utilis\u00e9es',
  gen_regional_intelligence: 'Renseignement R\u00e9gional',
  gen_updated: 'Mis \u00e0 jour',
  gen_outlook: 'Perspectives',
  gen_additional_sections: 'Sections suppl\u00e9mentaires disponibles',
  gen_select_prompt: 'S\u00e9lectionner un Pays',
  gen_select_prompt_desc: 'Choisissez un pays dans le menu ci-dessus pour commencer la g\u00e9n\u00e9ration.',

  // Blueprint View
  bp_sections_generated: 'Sections G\u00e9n\u00e9r\u00e9es',
  bp_economic_trends: 'Tendances \u00c9conomiques',
  bp_world_bank_data: 'Donn\u00e9es Banque Mondiale',
  bp_ai_studio: 'Studio IA',
  bp_quick_export: 'Export Rapide',
  bp_pdf_report: 'Rapport PDF',
  bp_generate_audio: "G\u00e9n\u00e9rer l'Aper\u00e7u Audio",
  bp_regenerate_audio: "Reg\u00e9n\u00e9rer l'Audio",
  bp_generate_infographic: "G\u00e9n\u00e9rer l'Infographie",
  bp_regenerate_infographic: "Reg\u00e9n\u00e9rer l'Infographie",
  bp_generate_references: 'G\u00e9n\u00e9rer les R\u00e9f\u00e9rences',
  bp_regenerate_references: 'Reg\u00e9n\u00e9rer les R\u00e9f\u00e9rences',
  bp_audio_overview: 'Aper\u00e7u Audio',
  bp_infographic: "Infographie d'Investissement",
  bp_references: 'Sources & R\u00e9f\u00e9rences',

  // Section Names
  sec_country_snapshot: 'Indicateurs Macro-\u00c9conomiques',
  sec_executive_summary: 'R\u00e9sum\u00e9 Ex\u00e9cutif',
  sec_pestle_analysis: 'Risque G\u00e9opolitique',
  sec_market_opportunity: 'Opportunit\u00e9 de March\u00e9',
  sec_government_capacity: 'Capacit\u00e9 Gouvernementale',
  sec_competitive_landscape: 'Paysage Concurrentiel',
  sec_business_model: "Mod\u00e8le d'Affaires",
  sec_risk_analysis: 'Analyse des Risques',
  sec_financial_projections: 'Cadre R\u00e9glementaire',
  sec_sovereign_risk: 'Risque Souverain',
  sec_social_impact: 'Capital Humain',
  sec_governance: 'Gouvernance',

  // Admin
  admin_title: 'Gestion des Utilisateurs',
  admin_users: 'Utilisateurs',
  admin_approve: 'Approuver',
  admin_reject: 'Rejeter',
  admin_pending: 'En Attente',
  admin_active: 'Actif',
  admin_gift_reports: 'Rapports Offerts',
  admin_email_config: 'Configuration Email',
  admin_bcc_email: 'Email CCI',

  // Pricing
  pricing_title: 'Tarification',
  pricing_per_report: 'Par Rapport',
  pricing_buy_report: 'Acheter un Rapport',
  pricing_coupon: 'Code Promo',
  pricing_redeem: '\u00c9changer',
  pricing_lucky: 'Tentez votre Chance',
  pricing_request_free: 'Demander un Rapport Gratuit',

  // Budget
  budget_title: 'Moniteur Budget IA',
  budget_available: 'Solde Disponible',
  budget_spent: 'Total D\u00e9pens\u00e9',
  budget_generations: 'Total G\u00e9n\u00e9rations',

  // Comparison
  compare_title: 'Comparaison des Pays',
  compare_subtitle: 'Comparez les indicateurs \u00e9conomiques entre pays',
  compare_select: 'S\u00e9lectionnez les pays \u00e0 comparer',

  // Payment
  payment_success: 'Paiement R\u00e9ussi !',
  payment_report_added: 'Votre rapport a \u00e9t\u00e9 ajout\u00e9 \u00e0 votre compte.',
};
